import { useQuery } from '@tanstack/react-query';
import { PulseLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

import { apiGet } from '../../services/_common';
import IssueGuide from '../IssueGuide';
import Slider from 'react-slick';
import { ERROR } from '../../_constants';
import { IUser } from '../../atoms';
import { arraySortByAscdOrder } from '../../utils/arraySortByAscdOrder';

const siteViewSettings = {
  dots: true,
  dotsClass: 'slick-dots slick-thumb',
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 30000,
};

// 현장 조감도
export const SiteView = ({ name, userInfo }: { name: string; userInfo: IUser }) => {
  const { hCd, sCd } = userInfo;
  const { t } = useTranslation();
  const {
    data: siteViews,
    isLoading,
    isError,
  } = useQuery(['siteImageGet', userInfo], () => fetchData(), {
    enabled: !!hCd && !!sCd && sCd !== '00000',
  });

  const fetchData = async () => {
    try {
      const res = await apiGet({ path: '/site/siteImage', req: { hCd, sCd } });
      if (res.status === 200) {
        const sortedArray = arraySortByAscdOrder(res.data.data.siteImage, 'imgSeq');
        return sortedArray;
      }
      return undefined;
    } catch (error) {
      console.error(error);
      throw new Error('error');
    }
  };

  const loading = isLoading || !siteViews;

  if (isError) return <IssueGuide type='error' text={ERROR} />;
  if (loading) {
    return (
      <div className='centered-content'>
        <PulseLoader color='rgb(0, 122, 255)' size='10px' />
      </div>
    );
  }

  return (
    <div className='imageBoard'>
      <div className='widget-header'>
        <div className='widget-title flex-between '>
          <span>{t(name)}</span>
        </div>
      </div>
      <div className='content' style={{ padding: '1rem' }}>
        <Slider {...siteViewSettings}>{siteViews.length > 0 ? siteViews.map((el: any) => <img key={el.imgSeq} src={el.imgFilename} alt='site view' />) : <IssueGuide type='img' size={8} />}</Slider>
      </div>
    </div>
  );
};
